export default "__VITE_ASSET__1f77f8ec__"